import { Plus, Users } from "lucide-react";
import { CreatePoolDialog } from "./createPoolViewDialog";
import { PoolCard } from "../component/poolCard";
// import { useApprovalViewModel } from "../viewmodel/approvalViewModel";
import Toast from "../../../../../components/Toast";
import { hideToast } from "../viewmodel/appprovalPool.action";
import { PoolModelData } from "../model/approvalPoolModel";
import { ConfirmDeleteModal } from "../../../../../components/ConfirmationPopUp";

// Accept approvalVM as a prop
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// @ts-ignore
export const PoolNameView = ({ approvalVM }: { approvalVM: any }) => {
  const { state, dispatch, deletePoolData, handleEditPool } = approvalVM;
  const handleConfirmDelete = async () => {
    await deletePoolData();
  };
  const setEditingPool = (pool: PoolModelData | undefined) => {
    dispatch({ type: "SET_EDITING_POOL", payload: pool });
  };
  const setIsPoolDialogOpen = (open: boolean) => {
    dispatch({ type: "SET_POOL_DIALOG_OPEN", payload: open });
  };
  // if (state.loading) {
  //   return (
  //     <div className="p-6">
  //       <div className="animate-pulse">
  //         <div className="h-8 bg-gray-200 rounded w-1/4 mb-6"></div>
  //         <div className="space-y-4">
  //           {[...Array(3)].map((_, i) => (
  //             <div key={i} className="bg-white rounded-lg shadow p-6">
  //               <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
  //               <div className="h-4 bg-gray-200 rounded w-1/2"></div>
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  return (
    <div>
      <div className="flex justify-end items-center mt-4 mb-4">
        <button
          onClick={() => {
            dispatch({ type: "RESET_POOL_FORM" });
            dispatch({ type: "SET_POOL_MODE", payload: "create" });
            dispatch({ type: "SET_EDITING_POOL", payload: undefined });
            setIsPoolDialogOpen(true);
          }}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors flex items-center"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Pool 
        </button>
      </div>
      <div className="space-y-4">
        <div>
          {state.loading && state.Pools.length === 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
              {Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm border p-4 animate-pulse"
                >
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                    <div className="flex-1">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="h-3 bg-gray-200 rounded"></div>
                    <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : state.Pools.length === 0 ? (
            <div className="px-6 py-12 text-center">
              <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
              <h3 className="text-sm font-medium text-gray-900">
                No pools found
              </h3>
              <p className="text-sm text-gray-500">
                Try adjusting your filters.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {state.Pools.map((pool: PoolModelData) => (
                <PoolCard
                  key={pool.id}
                  pool={pool}
                  onEdit={(pool) => {
                    dispatch({ type: "SET_POOL_MODE", payload: "edit" });
                    handleEditPool(pool);
                  }}
                  onDelete={(id) => {
                    dispatch({ type: "OPEN_DELETE_DIALOG", payload: id });
                  }}
                  onDetails={(pool) => {
                    // dispatch({ type: "SET_EDITING_POOL", payload: pool });
                    dispatch({ type: "SET_POOL_MODE", payload: "view" });
                    // setIsPoolDialogOpen(true);
                    handleEditPool(pool);
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <CreatePoolDialog
        open={state.isPoolDialogOpen}
        onOpenChange={(open) => {
          if (!open) {
            dispatch({ type: "RESET_POOL_FORM" });
            dispatch({ type: "SET_EDITING_POOL", payload: undefined });
            dispatch({ type: "SET_POOL_MODE", payload: "create" });
          }
          setIsPoolDialogOpen(open);
        }}
        existingPool={state.editingPool}
        approvalVM={approvalVM}
        mode={state.poolMode}
      />
      <Toast
        message={state.toast.message}
        type={state.toast.type}
        isVisible={state.toast.isVisible}
        onClose={() => dispatch(hideToast())}
      />
      <ConfirmDeleteModal
        open={state.deleteDialogOpen}
        title="Delete Pool?"
        entityName={
          state.Pools.find((p: any) => p.id === state.deletingFlowId)?.name
        }
        loading={state.loading}
        onCancel={() => dispatch({ type: "CLOSE_DELETE_DIALOG" })}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};
